import React from 'react';

import BoxInput from 'components/Toolbar/Shared/BoxInput';
import Dropdown from 'components/Toolbar/Shared/Dropdown';
import { intlGet } from 'utils/intlGet';
import { PaddingProps } from './models';
import styles from './styles.module.scss';

const Padding: React.FunctionComponent<PaddingProps & { dataTestId?: string }> = (props) => {
  const { padding, togglePadding, title, dataTestId = 'padding' } = props;

  return (
    <Dropdown
      className={styles.PaddingDropdown}
      stopClickPropagation={true}
      dataTestId={`${dataTestId}-dropdown`}
    >
      <div className={styles.title} data-testid={`${dataTestId}-dropdown-title`}>{intlGet('EditorToolbar', title)}</div>
      <BoxInput
        property={padding}
        toggleProperty={togglePadding}
        step={5}
        isShorthand={false}
        dataTestId={`${dataTestId}-boxInput`}
      />
    </Dropdown>
  );
};

export default Padding;
